import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import qs from 'qs';
import { ContentLoader } from '@saucelabs/sl-component-loader';

import { operations } from './../ducks/container';
import FormTitle from './../components/FormTitle';

class VerifyUserContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shouldRedirect: false,
    };
  }

  componentDidMount() {
    const { authenticated, verifyUser, queryParams } = this.props;

    if (queryParams?.token) {
      verifyUser({ authenticated, queryParams });
    }
  }

  componentDidUpdate(prevProps) {
    const { locationState } = this.props;

    if (locationState?.success && !prevProps.locationState) {
      this.setupRedirect();
    }
  }

  setupRedirect = () => {
    setTimeout(() => {
      this.setState({ shouldRedirect: true });
    }, 5000);
  }

  render() {
    const { shouldRedirect } = this.state;
    const { locationState, queryParams } = this.props;

    if (shouldRedirect || (!locationState && !queryParams?.token)) {
      return (
        <Redirect to={{ pathname: '/getting-started' }} />
      );
    }

    return (
      <ContentLoader show={!locationState}>
        <div>
          <FormTitle>Thank you for verifying your email address.</FormTitle>
          <div>
            <p>In a moment you will be redirected to the Sauce Labs onboarding page.</p>
            <p>Happy testing!</p>
          </div>
        </div>
      </ContentLoader>
    );
  }
}

const mapStateToProps = ({ user }, { location: { state, search } }) => ({
  authenticated: user?.isAuthenticated(),
  locationState: state,
  queryParams: qs.parse(search, { ignoreQueryPrefix: true }),
});

const mapDispatchToProps = {
  verifyUser: operations.verifyUser,
};

VerifyUserContainer.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  locationState: PropTypes.object,
  queryParams: PropTypes.object,
  verifyUser: PropTypes.func.isRequired,
};

VerifyUserContainer.defaultProps = {
  locationState: null,
  queryParams: {},
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VerifyUserContainer));
export { VerifyUserContainer, mapDispatchToProps };
